import { Country } from './Country';

export class Visa {
	public constructor(
		public readonly destinationCountry: Country,
		public readonly originCountry: Country,
		public readonly isVisaRequired: boolean,
		public readonly name: string,
		public readonly visaDuration: string | null = null,
		public readonly visaFeeCurrencyIso: string | null = null,
		public readonly visaFeeAmount: number | null = null,
		public readonly applicationDescription: string | null = null,
		public readonly applicationLink: string | null = null,
		public readonly requiresProofOfLanguage: boolean | null = null,
		public readonly requiresInterview: boolean | null = null,
		public readonly requiresMedicalExam: boolean | null = null,
		public readonly requiresProofOfFunds: boolean | null = null,
		public readonly proofOfFundsDescription: string | null = null,
		public readonly requiresBlockedBankAccount: boolean | null = null,
		public readonly otherInformation: string | null = null,
		public readonly originCountryDemonym: string | null = null,
		public readonly records: string | null = null,
		public readonly sourceLink: string | null = null,
		public readonly mayRequireInterview: boolean | null = null,
		public readonly requiresTravelAbroad: boolean | null = null,
		public readonly travelAbroadDescription: string | null = null,
		public readonly requiresBiometrics: boolean | null = null,
		public readonly requiresCriminalRecordsCheck: boolean | null = null,
		public readonly requiresProofOfAccommodation: boolean | null = null,
		public readonly requiresHealthInsurance: boolean | null = null,
		public readonly healthInsuranceDescription: string | null = null,
		public readonly otherExpenses: string | null = null
	) {}

	public static sameCountry(countryId: string): Visa {
		const country = new Country(countryId);

		return new Visa(country, country, false, country.name);
	}
}
